// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__z4xLD","card":"AboutUs_card__4F4W0","cardImg":"AboutUs_cardImg__tN9Qm"};